// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2tjXS","buttons":"RemoveExpirationActionButtons_buttons__C0kI0"};